
import gif from '../../assets/gifs/1.gif'
import { Contanier, ImgLoader, Title } from './styles';
const Loading = (loading) => {

    return (
        <Contanier >
            <ImgLoader src={gif} />
            <Title style={{ marginTop: 10 }}> Carregando...</Title>
        </Contanier>
    )
}
export default Loading;